/*
 * @Author: caiqin.xie
 * @since: 2023-09-04 18:19:11
 * @lastTime: 2023-11-09 15:34:13
 * @LastEditors: caiqin.xie
 * @message: 软件页
 * @url: www.picoxr.com/cn/software
 */
import React from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import SoftwareFooter from "./components/SoftwareFooter/index";
import Banner from "./components/Banner/index";
import Download from "./components/Download/index";
import IphoneOne from "./components/Iphone/index";
import Carousel from "./components/Carousel/index";
import styles from "./index.module.scss";
import request from '@/common/request'
import { COUNTRY_HREFLANG, COUNTRY_LIST, DOMAIN_API, SOFTWAREPOS, OSTYPE, STREAMINGTYPE, REMOTEPLAYTYPE, CASTTYPE } from '@/common/const'
const Software = (props:any) => {
  const {ctry, words, data} = props.data

  const {banners,castForPicoList,picoAssistantList,picoOsList,picoRemotePlaybackList} = data
  console.log(data);

  return (
    <>
      <Helmet>
        <title>{words?.software_seo_title}</title>
        <meta name="description" content={words?.software_seo_description} />
        <meta name="keywords" content={words?.software_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/software`} />
        {/*  生成hreflang */}
        {COUNTRY_LIST.map(item => (
          <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/software`} />
        ))}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles.page}>
        {/* banner区 */}
        <Banner banners={banners}  words={words} />
        {/* download区 */}
        <Download picoOsList={picoOsList} words={words} />
        {/* iphoneImg展示区 */}
        {/* <Iphone words={words}/> */}
        <IphoneOne words={words}/>
        {/* carousel区 */}
        <Carousel picoAssistantList={picoAssistantList} picoRemotePlaybackList={picoRemotePlaybackList} words={words} />
        {/* 底部dialog区 */}
        <SoftwareFooter castForPicoList={castForPicoList} words={words} />
      </main>
      <Footer />
    </>
  );
};
  // 获取数据
  function getInit (ctry: string) {
    return new Promise((resolve, reject) => {
      request.post(`${DOMAIN_API}/o/software/selectList`,{
        "bannerPositionId":SOFTWAREPOS,
        "picoOsId": OSTYPE,
        "picoAssistantId": STREAMINGTYPE,
        "picoRemotePlaybackId": REMOTEPLAYTYPE,
        "castForPicoId": CASTTYPE,
        "stationCode": "cn"
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
    })
  }

  Software.getInitialProps = (ctry: string) => {
    return getInit(ctry)
  };
export default Software;
